/**
 * @generated SignedSource<<ad110641c21146c610777f41114acea7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type twoSectionTopWidgetQueue$data = ReadonlyArray<{
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"homeSecondaryContentItemContent" | "sectionTopLeadSecondaryContentItemContent">;
  };
  readonly " $fragmentType": "twoSectionTopWidgetQueue";
}>;
export type twoSectionTopWidgetQueue$key = ReadonlyArray<{
  readonly " $data"?: twoSectionTopWidgetQueue$data;
  readonly " $fragmentSpreads": FragmentRefs<"twoSectionTopWidgetQueue">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "twoSectionTopWidgetQueue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeSecondaryContentItemContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "sectionTopLeadSecondaryContentItemContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "7843d39637da55c9c1bfee70afae3afa";

export default node;
